import React from 'react'
import Spinner from '../Spinner'
import componentStyles from './GoingLiveModal.module.scss'
import classnames from 'classnames'
import Modal from '@bt-react/components/Modal'
import TimedNotification from '@bt-react/components/TimedNotification'

const defaultState = {
  isCountdownComplete: false,
  isAnimationComplete: false,
  curContent: '3'
}

class GoingLiveModal extends React.Component {

  constructor (props) {

    super(props)
    this.state = { ...defaultState }

  }

  componentDidMount () {

    if (this.props.isLive) {

      this.setState(this.setGoingLive())

    }

  }

  componentDidUpdate (prevProps) {

    const { isCountingDown, isLive } = this.props
    const { isCountingDown: prevIsCountingDown, isLive: prevIsLive } = prevProps

    if (prevIsCountingDown !== isCountingDown || prevIsLive !== isLive) {

      if (!isCountingDown && !isLive) return this.reset()

    }

    if (prevIsLive !== isLive && isLive) {

      this.setState(this.setGoingLive())

    }

  }

  handleOnComplete = () => {

    switch (this.state.curContent) {

      case '3':
        return this.setState({ curContent: '2' })
      case '2':
        return this.setState({ curContent: '1' })
      case '1':
        return this.setState(this.setGoingLive())
      case 'goingLive':
        return typeof this.props.onComplete === 'function'
          ? this.props.onComplete()
          : this.setState({ curContent: '3', isAnimationComplete: true })
      default:
        return null

    }

  }

  setGoingLive = () => ({ curContent: 'goingLive', isCountdownComplete: true })

  getTimedContentSettings = id => {

    const content = {
      3: {
        body: this.countdownEle(3),
        easeIn: 0.4,
        duration: 0,
        easeOut: 0.4
      },
      2: {
        body: this.countdownEle(2),
        easeIn: 0.4,
        duration: 0,
        easeOut: 0.4
      },
      1: {
        body: this.countdownEle(1),
        easeIn: 0.4,
        duration: 0,
        easeOut: 0.4
      },
      goingLive: {
        body: this.goingLiveEle(),
        easeIn: 0.4,
        duration: 1,
        easeOut: 0.4
      }
    }

    return content[id]

  }

  reset = () => {

    this.setState({ ...defaultState })

  }

  countdownEle = number => {

    return <div className={componentStyles[`__countdown-text`]} >{number}</div>

  }

  goingLiveEle = () => {

    const notificationClasses = classnames(
      componentStyles[`__live-label`], {
        [componentStyles[`--hide`]]: this.state.isHidden
      }
    )

    return <span data-bdd='live-now-notification' className={notificationClasses}>LIVE NOW</span>

  }

  getBody = () => {

    const { isCountdownComplete, isAnimationComplete } = this.state
    const { isCountingDown = false, isLive = false } = this.props

    if ((isCountingDown && !isCountdownComplete) ||
      (isCountdownComplete && isLive && !isAnimationComplete)) {

      const { body, easeIn, duration, easeOut } = this.getTimedContentSettings(this.state.curContent)

      return <TimedNotification
        onComplete={this.handleOnComplete}
        secsEaseIn={easeIn}
        secsDisplay={duration}
        secsEaseOut={easeOut}
      >
        {body}
      </TimedNotification>

    }

    return <Spinner
      header={!isCountdownComplete && `Going live`}
      invert={true}
    />

  }

  showBackdrop = () => {

    if (!this.props.isLive || (this.props.isLive && !this.state.isCountdownComplete)) {

      return true

    }

    return false

  }

  render () {

    if (this.state.isAnimationComplete) return null

    return <Modal
      isOpen={true}
      concise={true}
      transparent={true}
      hideBorder={true}
      backdrop={this.showBackdrop()}
    >
      {this.getBody()}
    </Modal>

  }

}

export default GoingLiveModal
